const ScanFrameIcon = ({ className = "text-[#555]" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden
    className={className}
  >
    <path
      d="M6.5 3.5H4.5C3.94772 3.5 3.5 3.94772 3.5 4.5V6.5"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M13.5 3.5H15.5C16.0523 3.5 16.5 3.94772 16.5 4.5V6.5"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M6.5 16.5H4.5C3.94772 16.5 3.5 16.0523 3.5 15.5V13.5"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M13.5 16.5H15.5C16.0523 16.5 16.5 16.0523 16.5 15.5V13.5"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
);

export default ScanFrameIcon;
